<template>
  <div ref="mychart" :id="id" :data="data"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      ChartLineGraph: null,
    };
  },
  props: ["id", "data"],
  watch: {
    data: {
      handler(newValue, oldValue) {
        this.drawLineGraph(this.id, newValue);
      },
      deep: true,
    },
  },
  mounted: function () {
    this.drawLineGraph(this.id, this.data);
  },
  methods: {
    drawLineGraph(id, data) {
      let _this = this;
      let myChart = document.getElementById(id);
      this.ChartLineGraph = this.$echarts.init(myChart);
      this.ChartLineGraph.setOption(data);
      window.addEventListener("resize", function () {
        _this.ChartLineGraph && _this.ChartLineGraph.resize();
      });
    },
  },

  beforeDestroy() {
    if (this.ChartLineGraph) {
      this.ChartLineGraph.clear();
    }
  },
};
</script>
